import { createFileRoute } from '@tanstack/react-router';
import { getTenderPackageDetailsQuery } from '@/app/hooks/queries/useTenderPackages';
import { useSuspenseQuery } from '@tanstack/react-query';
import EvaluationActivityLog from '@/app/components/features/evaluations/EvaluationActivityLog';
import { EvaluationTypeLabelsEnum } from '@/app/utils/constants';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/tender-packages/$tenderPackageId/_layout/(home)/activity',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { tenderPackageId } = Route.useParams();
  const { data: tenderPackage } = useSuspenseQuery(getTenderPackageDetailsQuery(tenderPackageId));

  return (
    <EvaluationActivityLog
      resourceName={tenderPackage.name}
      evaluationId={tenderPackageId}
      resourceType={EvaluationTypeLabelsEnum.TENDER_PACKAGE}
      resourceCreatedAt={tenderPackage.createdAt}
    />
  );
}
